import useSWR from "swr";
import { fetcher, FetchError } from "lib/actions/fetcher";
import { endpointsAutodeskImport } from "../actions/endpointsAutodeskImport";
import { AutodeskHubModel } from "../types/AutodeskHubModel";

export function useAutodeskHubs(connectedAccountId: number | null) {
  const { data, error, isLoading, mutate } = useSWR<
    AutodeskHubModel[],
    FetchError
  >(
    connectedAccountId !== null &&
      endpointsAutodeskImport.hubs(connectedAccountId),
    fetcher,
    // A background retry would swap the error panel for a spinner, dropping a
    // Reconnect that is still waiting on its popup.
    { shouldRetryOnError: false },
  );

  return { hubs: data, hasError: !!error, error, isLoading, mutate };
}
